import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

export type EventLogEntryType = 'configuration' | 'firmware' | 'sealable_parameter';

export interface EventLogEntry {
    counter: number;
    timestamp: string;
    parameterIds: string[];
    newValue: string;
    eventType: EventLogEntryType;
}

interface GetEventLogResponse {
    chargerId: string;
    events: EventLogEntry[];
}

/** Fetches CTEP event log entries from `/api/event-log/{chargerId}`. */
@Injectable({ providedIn: 'root' })
export class EventLogService {
    readonly #http = inject(HttpClient);

    fetch(chargerId: string): Observable<EventLogEntry[]> {
        const normalised = chargerId.trim();
        return this.#http
            .get<GetEventLogResponse>(`/api/event-log/${encodeURIComponent(normalised)}`)
            .pipe(map((res) => res.events ?? []));
    }

    fetchPdf(chargerId: string): Observable<Blob> {
        const normalised = chargerId.trim();
        return this.#http.get(`/api/event-log/${encodeURIComponent(normalised)}/pdf`, {
            responseType: 'blob',
            headers: { Accept: 'application/pdf' },
        });
    }
}
